<ui-table
  [fields]="fields"
  [pager]="pager$"
  [filters]="filters$ | async"
  [itemsPage]="(page$ | async)?.current"
  [itemsPerPage]="(page$ | async)?.limit"
  [reload]="reload$"
  [contextMenuActions]="contextMenus"
  (select)="selectHandler($event)"
  (rowAction)="manageRowActions($event)">
  <div
    tableActions
    class="collection-items-actions">
<!--    <button-->
<!--      mat-button-->
<!--      mat-raised-button-->
<!--      (click)="exportHandler()">-->
<!--      Esporta tutti-->
<!--    </button>-->

    <button
      style="margin-left:10px;"
      mat-button
      mat-raised-button
      color='primary'
      (click)="exportSelected()">
      Seleziona ed esporta
    </button>
  </div>
  <div tableFilters>
    <ui-filters
      [dialogFilters]="MobileFiltersComponent"
      (action)="applyFilterWithDelayHandler($event)">
      <app-collection-items-filters
        [filters]="filtersObj$ | async"
        #desktopFilter>
      </app-collection-items-filters>
    </ui-filters>
  </div>
</ui-table>
